import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    rove: `${APP_CONFIG.apigee_host}/masmovil/v1/financials/ovid/orders/`,
  },
}
